import React from 'react';
import StandbyScreen from '@bizzabo/bap-ultimate/lib/components/StandbyScreen';

const ZoomStandbyScreen = ({children, hasStarted = false}) => {

    if (!hasStarted) {
        return <div style={{position: 'absolute'}}><StandbyScreen encryptedPayload={{}}/></div>;
    }

    return children;
};

export default ZoomStandbyScreen;
